import { StyleSheet } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';

const screen = StyleSheet.create({
	white: {
		flex: Dimens.flex1,
		backgroundColor: Colors.white,
	},
	column: {
		flexDirection: 'column',
		width: '100%',
	},
	fullWidth: {
		flex: Dimens.flex1,
		width: '100%',
	},
	bottomAligned: {
		flex: Dimens.flex1,
		justifyContent: 'flex-end',
	},
	listPadding: {
		paddingTop: Dimens.padding18,
		paddingHorizontal: Dimens.padding18,
	},
});

const loadingIndicator = StyleSheet.create({
	belowHeader: {
		flex: Dimens.flex1,
		marginTop: Dimens.padding50,
	},
});

const row = StyleSheet.create({
	iconLabel: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: Dimens.gap8,
	},
	dialogButtons: {
		flexDirection: 'row',
		gap: Dimens.gap20,
		marginTop: Dimens.padding30,
	},
});

const form = StyleSheet.create({
	helperTextHidden: {
		height: Dimens.size0,
	},
});

const header = {
	// Every stack header and the sticky home header read from here, so the three platforms stop
	// falling back to their own system title.
	title: {
		fontFamily: Fonts.barlowBold,
		fontSize: Dimens.fontSize16,
		color: Colors.gray900,
	},
	shadow: {
		shadowColor: Colors.black,
		shadowOffset: { width: Dimens.size0, height: Dimens.size5 },
		shadowOpacity: Dimens.opacity5,
		shadowRadius: Dimens.size10,
		elevation: Dimens.elevation10,
	},
};

const Styles = {
	card: {
		shadowSoft: {
			shadowColor: Colors.black66,
			shadowOffset: { width: Dimens.size0, height: Dimens.size8 },
			shadowOpacity: Dimens.opacity10,
			shadowRadius: Dimens.size16,
			elevation: Dimens.elevation5,
		},
	},
	header,
	screen,
	row,
	loadingIndicator,
	form,
};

export default Styles;
